
import React from 'react';
import { motion } from 'framer-motion';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  variants?: any;
  initial?: string;
  whileInView?: string;
  animate?: string;
  viewport?: any;
}

const Section: React.FC<SectionProps> = ({
  children,
  className = "",
  variants,
  initial = "initial",
  whileInView = "animate",
  animate,
  viewport = { once: true }
}) => {
  return (
    <motion.section 
      className={`relative flex flex-col justify-center px-4 md:px-6 py-16 md:py-20 ${className}`}
      initial={initial} 
      whileInView={whileInView}
      animate={animate}
      viewport={viewport} 
      variants={variants}
    >
      {children}
    </motion.section>
  );
};

export default Section;
